// src/utils/useExcelExport.js
import { get } from "lodash";
import { useState, useEffect, useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";

/**
 * Hook to support exporting all tables inside a wrapper element.
 * @param {Array<any>} deps – trigger ref scan when tables change
 * @param {string} filename – name for the Excel file
 * @param {string} sheetName – name for the Excel tab
 */
export function useExcelExport(deps = [], filename = "export", sheetName = "Sheet") {
  const wrapperRef = useRef(null);
  const [tableWrapperEl, setTableWrapperEl] = useState(null);

  useEffect(() => {
    if (get(wrapperRef,'current')) {
      setTableWrapperEl(get(wrapperRef,'current'));
    }
  }, deps);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableWrapperEl,
    filename,
    sheet: sheetName,
  });

  return { wrapperRef, onDownload, isReady: !!tableWrapperEl };
}
